import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A5ABB3",
      d: "m26 0 10 10v28.016C36 39.112 35.11 40 34.013 40H1.987A2 2 0 0 1 0 38.016V1.984C0 .888.89 0 1.987 0zm-6 20h6l-8-8-8 8h6v8h4z"
    }, null, -1)
  ]))]))
}
export default { render: render }